import registerStudentTemplate from '../register-student/register-student.html';
import template from './card-id-validation.html';

export class CardIdValidationCardController {
/** @ngInject */
  constructor(
    $log, $mdDialog, $state, $q, $rootScope, ProximityCardService, StudentService
  ) {
    this.$log = $log;
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.$q = $q;
    this.ProximityCardService = ProximityCardService;
    this.StudentService = StudentService;
  }

  cancel() {
    this.$state.go('modules.dashboard');
    this.$mdDialog.cancel();
  }

  registerStudent() {
    this.ProximityCardService.getProximityCardStudents(this.cardId).then(students => {
      this.setStudents({students: students.ownerCardList});
      this.$state.go('modules.dashboard');
      if (students.ownerCardList.length > 1) {
        this.nextStep();
      } else if (students.ownerCardList.length === 0) {
        this.$mdDialog.hide();
        this.$mdDialog.show(
          this.$mdDialog.detailsError({
            locals: {error: {
              data: {Code: 'STUDENT_NOT_ASSIGN_TO_SCHOOL_COMMON_ROOM'}
            }}
          })
        );
      } else if (students.ownerCardList[0].studentAssignedToCardOwner.registeredBy) {
        this.$mdDialog.hide();
        this.$mdDialog.show(
          this.$mdDialog.detailsError({
            locals: {error: {
              data: {Code: 'STUDENT_IS_ALREADY_REGISTERED'}
            }}
          })
        );
      } else {
        this.$mdDialog.show({
          resolve: {
            students: () => {
              return this.StudentService.getForRegistration({studentId: students.ownerCardList[0].studentAssignedToCardOwner.scrStudentId}).then(response => {
                return response.data.students;
              }).catch(error => {
                this.$mdDialog.show(
                  this.$mdDialog.extendError({
                    locals: {error}
                  })
                );
              });
            }
          },
          bindToController: true,
          controllerAs: 'ctrl',
          controller: 'RegisterStudentController',
          locals: {
            currentClassRoom: this.currentClassRoom,
            access: this.access,
            classRooms: this.classRooms
          },
          template: registerStudentTemplate,
          disableParentScroll: true,
          clickOutsideToClose: true
        }).then(() => {
          this.$rootScope.$broadcast('dashboard.config.studentIsRegistered');
        });
      }
    }).catch(error => {
      this.$mdDialog.hide();
      if (error.status === 400) {
        this.$mdDialog.show(
          this.$mdDialog.detailsError({
            locals: {error: {
              data: {Code: error.Code}
            }}
          })
        );
      } else if (error.status === 404) {
        this.$mdDialog.show(
          this.$mdDialog.detailsError({
            locals: {error}
          })
        );
      } else {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      }
    });
  }
}

export const CardIdValidation = {
  bindings: {
    nextStep: '&',
    setStudents: '&',
    cardId: '@',
    students: '=',
    access: '=',
    currentClassRoom: '=',
    classRooms: '='
  },
  controller: CardIdValidationCardController,
  template
};
